module.exports = __webpack_public_path__ + "media/images/logo-fisrst-part-red-171a94485a11ff03f65f8057f913adf1.svg";